import React from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { Text } from '@wix/design-system';
import s from './Content.scss';

export const SwitchContent = ({ texts }: { texts: React.ReactNode[] }) => {
  const [index, setIndex] = React.useState(0);
  const firstNode = React.useRef(null);
  const secondNode = React.useRef(null);
  const nodeRef = index ? firstNode : secondNode;

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((currentIndex) => (currentIndex + 1) % 2);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <SwitchTransition mode='out-in'>
      <CSSTransition
        key={texts[index]?.toString()}
        nodeRef={nodeRef}
        addEndListener={(done) => {
          (nodeRef.current as any).addEventListener(
            'transitionend',
            done,
            false,
          );
        }}
        classNames={{
          enter: s.fadeEnter,
          enterActive: s.fadeEnterActive,
          exit: s.fadeExit,
          exitActive: s.fadeExitActive,
        }}
        in={true}
      >
        <div ref={nodeRef}>
          <Text className={s.withDash} light weight='bold'>
            {texts[index]}
          </Text>
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};
